import { FontWeight, TextAlignment, TextColor } from '@bm-js/atlascloud-shared'

export const fontSizes = {
  '1rem': 'text-base @2xl/grid:text-base',
  '1.125rem': 'text-base @2xl/grid:text-lg',
  '1.25rem': 'text-base @2xl/grid:text-xl',
  '1.5rem': 'text-ase @2xl/grid:text-2xl',
  '2rem': 'text-lg @2xl/grid:text-3xl',
  '2.5rem': 'text-2xl @2xl/grid:text-4xl',
  '3rem': 'text-2xl @2xl/grid:text-5xl',
  '4rem': 'text-3xl @2xl/grid:text-6xl',
}

export const fontWeights = {
  thin: 'font-thin',
  extralight: 'font-extralight',
  light: 'font-light',
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
  black: 'font-black',
  extrabold: 'font-extrabold',
}

export const textAligns = {
  left: 'text-left',
  center: 'text-center mx-auto',
  'center-mobile':
    '@2xl/grid:mx-[unset] @2xl/grid:text-left text-center mx-auto',
  right: 'text-right',
}

export const textColors = {
  black: 'text-black',
  white: 'text-white',
  'neutral-700': 'text-neutral-700',
  'primary-400': 'text-customerPrimary-400',
  'primary-300': 'text-customerPrimary-300',
  'primary-200': 'text-customerPrimary-200',
}

export const leadings = {
  default: '',
  105: '!leading-[105%]',
  110: '!leading-[110%]',
  120: '!leading-[120%]',
  130: '!leading-[130%]',
  140: '!leading-[140%]',
  150: '!leading-[150%]',
}

export const maxWidths: Record<string, string> = {
  'max-w-xs': 'max-w-xs',
  'max-w-sm': 'max-w-sm',
  'max-w-md': 'max-w-md',
  'max-w-lg': 'max-w-lg',
  'max-w-xl': 'max-w-xl',
  'max-w-2xl': 'max-w-2xl',
  'max-w-3xl': 'max-w-3xl',
  'max-w-4xl': 'max-w-4xl',
}

export const textAlignOptions: { label: string; value: TextAlignment }[] = [
  {
    label: 'Vänster',
    value: 'left',
  },
  {
    label: 'Centrerad',
    value: 'center',
  },
  {
    label: 'Centrerad på mobil',
    value: 'center-mobile',
  },
  {
    label: 'Höger',
    value: 'right',
  },
]

export const fontSizeOptions = [
  {
    label: 'XXS',
    value: '1rem',
  },
  {
    label: 'XS',
    value: '1.125rem',
  },
  {
    label: 'S',
    value: '1.25rem',
  },
  {
    label: 'M',
    value: '1.5rem',
  },
  {
    label: 'L',
    value: '2rem',
  },
  {
    label: 'XL',
    value: '2.5rem',
  },
  {
    label: '2XL',
    value: '3rem',
  },
  {
    label: '3XL',
    value: '4rem',
  },
]

export const fontWeightOptions: { label: string; value: FontWeight }[] = [
  {
    label: 'Lätt',
    value: 'light',
  },
  {
    label: 'Normal',
    value: 'normal',
  },
  {
    label: 'Medium',
    value: 'medium',
  },
  {
    label: 'Semi Bold',
    value: 'semibold',
  },
  {
    label: 'Bold',
    value: 'bold',
  },
  {
    label: 'Extra Bold',
    value: 'extrabold',
  },
]

export const colorOptions: { label: string; value: TextColor }[] = [
  {
    label: 'Svart',
    value: 'black',
  },
  {
    label: 'Vit',
    value: 'white',
  },
  {
    label: 'Mörkgrå',
    value: 'neutral-700',
  },
  {
    label: 'Primär färg',
    value: 'primary-400',
  },
  {
    label: 'Primär färg ljus',
    value: 'primary-300',
  },
  {
    label: 'Primär färg ljusare',
    value: 'primary-200',
  },
]

export const leadingOptions = [
  {
    label: 'Standard',
    value: 'default',
  },
  {
    label: '105%',
    value: '105',
  },
  {
    label: '110%',
    value: '110',
  },
  {
    label: '120%',
    value: '120',
  },
  {
    label: '130%',
    value: '130',
  },
  {
    label: '140%',
    value: '140',
  },
  {
    label: '150%',
    value: '150',
  },
]

export const maxWidthOptions = [
  { value: '', label: 'Ingen' },
  { value: 'max-w-xs', label: 'XS' },
  { value: 'max-w-sm', label: 'S' },
  { value: 'max-w-md', label: 'M' },
  { value: 'max-w-lg', label: 'L' },
  { value: 'max-w-xl', label: 'XL' },
  { value: 'max-w-2xl', label: '2XL' },
  { value: 'max-w-3xl', label: '3XL' },
  { value: 'max-w-4xl', label: '4XL' },
]
